import { render, staticRenderFns } from "./pageFooter.vue?vue&type=template&id=33b66882&scoped=true&"
var script = {}
function injectStyles (context) {
  
  var style0 = require("./pageFooter.vue?vue&type=style&index=0&id=33b66882&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "33b66882",
  "4bbf481d"
  
)

component.options.__file = "pageFooter.vue"
export default component.exports